export { BadgeCheck as default } from './BadgeCheck';
